import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useDocumentTitle = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // Update document title when language changes
    document.title = t('app.title');
  }, [t, i18n.language]);
};
